var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

// GSAP Library
require('TimelineLite');
require('gsap-css-plugin');
require('gsap-ease-pack');

function VermontPreloader() {
  this.el = document.querySelector('.home-preloader');

  if(!this.el) {
    return;
  }

  if(window.location.search.indexOf('test') !== -1) {
    $(this.el).remove();
    return;
  }

  document.body.classList.add('preload-animation');

  this.timeline = new TimelineLite({
    onStart: function() {
      this.el.classList.add('in');
    }.bind(this),
    onComplete: function() {
      this.el.classList.add('out');
      document.body.classList.remove('preload-animation');
    }.bind(this)
  });

  var logoImage = this.el.querySelector('img');
  
  if(logoImage.complete) {
    this.buildLogo();
  } else {
    logoImage.addEventListener('load', this.buildLogo.bind(this));
  }

  $(this.el).one('click', function() {
    if(this.timeline.time() < this.timeline.getLabelTime('ending')) {
      this.timeline.seek('ending+=.5');
    }
  }.bind(this));
}

VermontPreloader.prototype.buildLogo = function() {
  var letters = document.querySelectorAll('.vsc-logo-animation [data-letter]');

  var delays = ['0', '-=.2', '-=.15', '-=.25', '-=.1', '-=.4', '-=.15', '-=.3'];

  for(var i = 0; i < letters.length; i++) {
    var l = letters[i];

    var words = l.getAttribute('data-letter') === 'smoke-and-cure';

    var target = words ? l : l.firstElementChild;
    var fromY = words ? '250%' : '-100%';
    var fromO = words ? 0 : 1;
    var ease = words ? Power3.easeOut : Bounce.easeOut;

    this.timeline.timeScale(0.8);

    this.timeline.from(target, .4, {
      y: fromY,
      opacity: fromO,
      ease: ease
    }, delays[i]);
  }

  var heading = document.querySelector('.home-preloader h1');

  this.timeline.from(heading, .6, {
    x: (100*2/3)+'%',
    opacity: 0,
    ease: Back.easeOut
  }, '+=.4');

  this.timeline.add('ending', '+=0');

  this.timeline.to(this.el, .6, {
    opacity: 0,
    onStart: function() {
      $(window).trigger('vsc-page-ready');
    }.bind(this)
  }, '+=.7');

  var header = document.querySelector('header.header .header-bar');
  var nextSection = document.querySelector('.page-hero-full + section');

  this.timeline.from(header, .6, {
    y: '-70px'
  }, '-=.6');

  this.timeline.from(nextSection, .6, {
    y: '70px'
  }, '-=.6');
}

module.exports = VermontPreloader;